import {Component, Input, OnInit, Output, EventEmitter, ElementRef, ViewChild} from '@angular/core';
import {SessionStorageService} from 'ngx-webstorage';
import {formatNumber, DatePipe, DecimalPipe} from '@angular/common';
import {TranslateService} from '../translate.service';
import {NgxLoopDocumentService} from './ngx-loop-document.service';
import { ConfigurationService } from '../depends/configuration.service';
import {SecToDateTime} from '../sec-to-date-pipe';
import { DayMonth, DayPipe, FullDatePipe, HourPipe, SafeSafari, ShortDatePipe } from '../depends/pipe/date.pipe';

@Component({
  selector: 'NgxLoopDocument',
  templateUrl: './ngx-loop-document.component.html',
  styleUrls: ['./ngx-loop-document.component.css' ]
})

export class NgxLoopDocumentComponent implements OnInit {

    structure:any = null;
    printing: boolean = false;
    loading: boolean = false;
    downloaded:boolean = false;

    @Input() type:string = "";
    @Input() resource_id:number|number[] = [];
    @Input() customParams:any = null;
    @Input() external:boolean = false;

    @Input() externalLoading:boolean = false;

    @Input() showprintbutton:boolean = true;
    @Output() isready:EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild("iframe", {static: true}) iframe: ElementRef<HTMLIFrameElement>;

  constructor(
    private fullDatePipe: FullDatePipe,
    private shortDatePipe: ShortDatePipe,
    private hourPipe: HourPipe,
    private dayMonth: DayMonth,
    private dayPipe: DayPipe,
    private secToDateTime: SecToDateTime,
    private sessionStorage: SessionStorageService,
    public translate : TranslateService,
    public NgxLoopDocumentService : NgxLoopDocumentService,
    private configurationService:ConfigurationService,
    private datePipe: DatePipe,
    private decimalPipe:DecimalPipe
  ) {}

  ngOnInit() {
    console.log("on init")
    this.getDocument();
  }

  public concatStyles(styles:any[]):any{
    let result = new Object();
    for(let style of styles){
      result = Object.assign(result, style);
    }
    return result;
  }

  public translateContent(text){
    let items = text.match(/(\{\{(.*?)\}\})/g);
    if(items != null && Array.isArray(items) && items.length){
      for(let item of items){
        if(item.includes('|')){
          let value = item.split('|')[0].replace("{{","");
          let pipe = item.split('|')[1].replace("}}","");
          let result = value;
          if(pipe == "translate"){
            result = this.translate.data[value];
          }else if(pipe.includes("date")){
            if(pipe.includes("date:")){
              let format = pipe.replace("date:","");
              let locale = this.configurationService.getConfigLocale();
              result = SafeSafari.formatDate(value,format,locale,null);
            }
          }else if(pipe.includes("number")){
            if(pipe.includes("number:")){
              let format = pipe.replace("number:","");
              result = this.decimalPipe.transform(value,format);
            }
          }else if(pipe.includes("time")){
            if(pipe.includes("time:")){
              let format = pipe.replace("time:","");
              result = this.secToDateTime.transform(value,format);
            }
          }
          text = text.replace(item, result);
        }else{
          try{
            text = text.replace(item, this.translate.data[item.replace("{{","").replace("}}","")]);
          }catch(error){
            console.log(error);
          }
        }
      }
    }
    return text;
  }

  public convertTranslateHTML(htmlString){
    let references: any[];

    references = htmlString.split("{{").map((reference) => {
      if(reference.includes("}}") == true) return reference.split("}}")[0];
    });
    for(let reference of references){
      let translated = this.translate.data[reference];
      if(reference != null) htmlString = htmlString.replace(`{{${reference}}}`, ((translated)?translated:reference));
    }
    return htmlString;
  }

  public finished(){
    this.externalLoading = false;
    if(this.downloaded){
      this.downloaded = false;
      setTimeout(()=>{
        this.isready.emit(true);
      },1000);
    }
  }
  public getValueFromObject(value, obj){
    let result = obj;
    let paths = value.split(".");
    for(let path of paths){
      result = result[path];
    }
    return result;
  }

  public getDocumentCallback(document) {
    this.finished();
    this.structure = document;
    this.downloaded = true;
  }

  public getDocumentErrorCallback(e) {
    console.log(e);
    this.downloaded = true;
    this.finished();
  }

  private getDocument(){

    console.log("getting document", this.resource_id, this.type,this.external);

    if(!this.external){
      this.NgxLoopDocumentService.getDocument(this.type,this.resource_id,this.customParams)
        .then((document) => this.getDocumentCallback(document))
        .catch(e => this.getDocumentErrorCallback(e));
    }else{
      this.NgxLoopDocumentService.getExternalDocument(this.type,this.resource_id,this.customParams)
        .then((document) => this.getDocumentCallback(document))
        .catch(e => this.getDocumentErrorCallback(e));
    }
  }

  public format(value, type, format){
    let result = value;
    if(value != null){
      try{
        switch(type){
          case 'number':
            result = formatNumber(Number(value), this.translate.lang, format);
            break;
          case 'text':
            result = value.toString();
            break;
          case 'datetime':
            if(this[format] != null)
              result = this[format].transform(value);
            break;
        }
      }catch(error){
        console.log(error)
        result = value;
      }
    }
    return result;
  }

  public downloadPDFV2() {
    this.printing = true;
    let reports = window.document.getElementById("document").innerHTML;
    //this.iframe.nativeElement.contentDocument.write(reports);
    this.iframe.nativeElement.contentWindow.document.body.innerHTML = reports
    if(this.structure.rows)
      this.iframe.nativeElement.contentWindow.document.head.innerHTML = window.document.head.innerHTML;
    setTimeout(() => {
      this.iframe.nativeElement.contentWindow.focus();
      this.iframe.nativeElement.contentWindow.print();
      this.printing = false;
    },3000)
    window.focus();
  }

}
